import { DeleteOutline as DeleteOutlineIcon, Edit as EditIcon } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { AuthContext } from 'providers/authProvider';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { hasPermission } from 'services/auth';

import { ConfirmModal, MoreMenu, NOTIFICATION_TYPE, Notification } from 'components';
import { useDeleteBuyer } from 'features/buyers/hooks/useDeleteBuyer';

const BuyerActionButton = ({ buyer }) => {
  const { user } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const { mutate: deleteBuyer, isLoading } = useDeleteBuyer({
    onSuccess: () => {
      setAnchorEl(null);
      Notification(NOTIFICATION_TYPE.SUCCESS, 'Buyer is removed successfully.');
    },
    onError: (err) => {
      Notification(NOTIFICATION_TYPE.DANGER, err.message);
    },
  });

  return (
    <>
      <MoreMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
        <MenuItem
          onClick={() => setShowConfirm(true)}
          disabled={!hasPermission(user, { resource: 'buyer', action: 'delete' }) || isLoading}
          data-testid="delete-buyer"
        >
          <DeleteOutlineIcon sx={{ mr: '1rem' }} />
          Remove
        </MenuItem>
        <MenuItem disabled={!hasPermission(user, { resource: 'buyer', action: 'update' })}>
          <Link to={`edit/${buyer.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <EditIcon sx={{ mr: '1rem' }} />
            Edit
          </Link>
        </MenuItem>
      </MoreMenu>

      <ConfirmModal
        show={showConfirm}
        handleClose={() => setShowConfirm(false)}
        title="Remove Buyer"
        content="Are you sure you want to remove this buyer?"
        onConfirm={() => deleteBuyer(buyer.id)}
      />
    </>
  );
};

export default BuyerActionButton;
